import {useLayoutEffect,useRef} from 'react';
import {Button} from '@platform/ui/Button';
import {useCopy} from '@platform/ui/config';
import {RoomSoundControl} from './RoomSoundControl';

export function RoomControls({broadcast,onBroadcast,sound,onSound,mediaId="room-broadcast-media"}:{broadcast:boolean;onBroadcast:()=>void;sound:boolean;onSound:()=>void;mediaId?:string}){
 const t=useCopy();
 const actions=useRef<HTMLDivElement>(null);
 const previous=useRef<{broadcast:boolean;x:number;y:number}|null>(null);
 useLayoutEffect(()=>{
  const camera=actions.current?.querySelector('.broadcast-control .room-control-face');
  const sound=actions.current?.querySelector<HTMLElement>('.room-sound-control');
  const face=sound?.querySelector('.room-control-face');
  if(!camera||!sound||!face)return;
  const anchor=camera.getBoundingClientRect(),position=face.getBoundingClientRect();
  // Measure relative to the camera: scrolling the room must not change this path.
  const next={broadcast,x:position.x-anchor.x,y:position.y-anchor.y},prior=previous.current;
  previous.current=next;
  if(!prior||prior.broadcast===broadcast||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const movement=sound.animate([{transform:`translate(${prior.x-next.x}px,${prior.y-next.y}px)`},{transform:'translate(0,0)'}],{duration:160,easing:'ease-out'});
  return ()=>movement.cancel();
 },[broadcast]);
 return <div className="room-actions" ref={actions}>
  <Button className={'room-control broadcast-control'+(broadcast?' active':'')} aria-label={t(broadcast?'room.hideBroadcast':'room.showBroadcast')} title={t(broadcast?'room.hideBroadcast':'room.showBroadcast')} aria-expanded={broadcast} aria-controls={mediaId} onClick={onBroadcast}>
   <span className="room-control-face" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">{broadcast?<><rect x="3" y="6" width="12" height="12" rx="2"/><path d="m15 10 6-3v10l-6-3Z"/></>:<><path d="M9 6h4a2 2 0 0 1 2 2v2l6-3v10l-3-1.5M15 15v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8c0-.6.2-1 .6-1.4M3 3l18 18"/></>}</svg></span>
  </Button>
  <RoomSoundControl compact enabled={sound} onToggle={onSound}/>
 </div>;
}
